export default {
	data() {
		return {
			options: [
				{ text: '1 day before', minutes: 1440 },
				{ text: '1 week before', minutes: 10080 },
				{ text: '2 weeks before', minutes: 20160 },
				{ text: '3 weeks before', minutes: 30240 },
				{ text: '1 month before', minutes: 40320 }
			]
		};
	},
	methods: {
		getTextFromMinutes(minutes) {
			return this.options.find(x => x.minutes === minutes).text;
		}
	}
};
